import { CalendarService } from '@b2b/common/services/calendar';
import angular from 'angular';

FormatDateFilterFactory.$inject = ['CalendarService'];

function FormatDateFilterFactory(calendarService: CalendarService) {
  return function FormatDateFilter(input: unknown, format: string) {
    return input ? calendarService.toFormat(calendarService.parseDate(input), format) : '';
  };
}

export const FormatDateFilterModule = angular
  .module('acme.common.filter.format-date', [])
  .filter('formatDate', FormatDateFilterFactory).name;
